'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PRODUCT_CRM = exports.PRODUCT_CRM = ['sales'];

var PRODUCT_SALES_PRO_LEGACY = exports.PRODUCT_SALES_PRO_LEGACY = ['sales-pro'];

var PRODUCT_SALES_POWER_USER = exports.PRODUCT_SALES_POWER_USER = ['sales-power'];
var PRODUCT_SALES_FREE = exports.PRODUCT_SALES_FREE = ['sales'];
var PRODUCT_SALES_STARTER = exports.PRODUCT_SALES_STARTER = ['sales-starter'];

// Sales Pro users are grandfathered into Sales Professional.
var PRODUCT_SALES_PROFESSIONAL = exports.PRODUCT_SALES_PROFESSIONAL = ['sales-pro-bundle'].concat(PRODUCT_SALES_PRO_LEGACY);

var PRODUCT_SALES_PROFESSIONAL_ADDITIONAL_USER = exports.PRODUCT_SALES_PROFESSIONAL_ADDITIONAL_USER = ['sales-pro-additional-seat'];
var PRODUCT_SALES_ENTERPRISE = exports.PRODUCT_SALES_ENTERPRISE = ['sales-enterprise-bundle'];
var PRODUCT_SALES_ENTERPRISE_ADDITIONAL_USER = exports.PRODUCT_SALES_ENTERPRISE_ADDITIONAL_USER = ['sales-enterprise-additional-seat'];

var PRODUCT_MARKETING_FREE = exports.PRODUCT_MARKETING_FREE = ['marketing-free-2016'];
var PRODUCT_MARKETING_STARTER = exports.PRODUCT_MARKETING_STARTER = ['marketing-starter-2016'];
var PRODUCT_MARKETING_BASIC = exports.PRODUCT_MARKETING_BASIC = ['marketing-basic-2011', 'marketing-basic-2012', 'marketing-basic-2013'];
var PRODUCT_MARKETING_PRO = exports.PRODUCT_MARKETING_PRO = ['marketing-pro-2011', 'marketing-pro-2012', 'marketing-pro-2013'];
var PRODUCT_MARKETING_ENTERPRISE = exports.PRODUCT_MARKETING_ENTERPRISE = ['marketing-ent-2011', 'marketing-ent-2012', 'marketing-ent-2013'];
var PRODUCT_MARKETING_STARTER_EMAIL = exports.PRODUCT_MARKETING_STARTER_EMAIL = ['marketing-starter-2018'];

var PRODUCT_SERVICE_FREE = exports.PRODUCT_SERVICE_FREE = ['sales'];
var PRODUCT_SERVICE_STARTER = exports.PRODUCT_SERVICE_STARTER = ['service-starter'];
var PRODUCT_SERVICE_PROFESSIONAL = exports.PRODUCT_SERVICE_PROFESSIONAL = ['service-professional-bundle'];
var PRODUCT_SERVICE_PROFESSIONAL_ADDITIONAL_USER = exports.PRODUCT_SERVICE_PROFESSIONAL_ADDITIONAL_USER = ['service-professional-additional-seat'];
var PRODUCT_SERVICE_ENTERPRISE = exports.PRODUCT_SERVICE_ENTERPRISE = ['service-enterprise-bundle'];
var PRODUCT_SERVICE_ENTERPRISE_ADDITIONAL_USER = exports.PRODUCT_SERVICE_ENTERPRISE_ADDITIONAL_USER = ['service-enterprise-additional-seat'];

var ADDON_REPORTING = exports.ADDON_REPORTING = ['reporting', 'reporting-grandfathered'];
var ADDON_ADS = exports.ADDON_ADS = ['ads', 'ads-grandfathered'];
var ADDON_WEBSITE_STARTER = exports.ADDON_WEBSITE_STARTER = ['sites', 'sites-basic-2014', 'sites-grandfathered'];

var ADDON_WEBSITE_UNLIMITED = exports.ADDON_WEBSITE_UNLIMITED = ['sites-unlimited', 'sites-unlimited-2014'];

var ADDON_DEDICATED_IP = exports.ADDON_DEDICATED_IP = ['dedicated-ip'];
var ADDON_ADDITIONAL_PORTAL = exports.ADDON_ADDITIONAL_PORTAL = ['placeholder'];

var ADDON_TRANSACTIONAL_EMAIL = exports.ADDON_TRANSACTIONAL_EMAIL = ['transactional-email'];

var ADDON_CMS_FREE = exports.ADDON_CMS_FREE = ['cms-standalone-free'];
var ADDON_CMS_PAID = exports.ADDON_CMS_PAID = ['cms-standalone-paid'];

var ADDITIONAL_CONTACTS = exports.ADDITIONAL_CONTACTS = ['additional-contacts-and-emails', 'additional-contacts-and-emails-5x'];


//////////////////
// WEBPACK FOOTER
// ./js/constants/ParcelGroups.js
// module id = 542
// module chunks = 3 4 5